import { useRef } from 'react';
import { useEventListener } from '~/hooks/useEventListener';

export function useScrollPosition() {
    const documentRef = useRef<Document>(typeof window !== 'undefined' ? document : null);

    const debounce = (fn: (...args: any[]) => void) => {
        let frame: number;

        return (...params: any[]) => {
            if (frame) {
                cancelAnimationFrame(frame);
            }

            frame = requestAnimationFrame(() => {
                fn(...params);
            });
        };
    };

    const storeScroll = () => {
        if (typeof window !== 'undefined') {
            document.body.style.setProperty('--scrollTop', window.scrollY.toString() + 'px');
        }
    };

    // Listen for new scroll events, here we debounce our `storeScroll` function
    // document.addEventListener("scroll", debounce(storeScroll), { passive: true });

    useEventListener('scroll', debounce(storeScroll), documentRef, {
        passive: true,
    });

    // Update scroll position for first time
    storeScroll();
}
